/**
 * Checks whether the input is an array. If so returns the first element otherwise
 * returns the input object.
 * @param objectToCheck the object to check
 */
export default function checkEntityArray(objectToCheck: any): any {
    if (objectToCheck) {
        if (Array.isArray(objectToCheck)) {
            if (objectToCheck.length > 0) {
                return objectToCheck[0];
            }
        } else {
            return objectToCheck;
        }
    }
}
